import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { TTenantLoginLoaderProps } from '@/backoffice/features/tenants/components/tenant-login-loader/tenant-login-loader.types';
import { useLoginTenant } from '@/backoffice/features/tenants/hooks/use-login-tenant/use-login-tenant';
import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';
import { ErrorBoundary } from '@/shared/features/error/components/error-boundary/error-boundary';
import { selectBackofficeTenantIdToken } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const TenantLoginLoader: React.FC<TTenantLoginLoaderProps> = ({
  children,
}) => {
  const { t } = useTranslation();
  const { tenantId } = useParams();
  const { loginTenant, isLoggingIn, isError } = useLoginTenant();
  const idToken = useAppSelector(selectBackofficeTenantIdToken);

  useEffect(() => {
    loginTenant(tenantId);
  }, [tenantId]);

  if (isError) {
    return <ErrorBoundary title={t('backoffice:error_loading_tenant')} />;
  }

  if (isLoggingIn || (tenantId && !idToken)) {
    return (
      <FullscreenLoader loaderText={t('backoffice:logging_into_tenant')} />
    );
  }

  return <>{children}</>;
};
